<h5 data-e2e="modal-header" class="modal-title w-100" [ngClass]="titleClass">
  <ng-content></ng-content>
</h5>
@if (showCloseBtn) {
<button
  data-e2e="close-modal-window-btn"
  type="button"
  class="close d-flex align-items-center justify-content-center"
  data-dismiss="modal"
  aria-label="Close"
  (click)="dismiss.emit()"
>
  <fa-icon
    [icon]="['fas', 'xmark']"
    class="d-flex align-items-center justify-content-center"
  ></fa-icon>
</button>
}
